var AnalyticsMetric = {
  VIEW_AGENT_PROFILE: {
    metricKey: 'listing.event.public.view_agent_profile'
  },
  PHOTO_VIEW: {
    metricKey: 'listing.event.public.photo_view'
  },
  VIEW_HISTORY: {
    metricKey: 'listing.event.public.view_history'
  },
  VIEW_VIDEO: {
    metricKey: 'listing.event.public.view_video'
  },
  VIEW_LISTING: {
    metricKey: 'listing.event.public.view'
  },
  PRINT_FRIENDLY: {
    metricKey: 'listing.event.public.print_friendly'
  },
  VIEW_ADVERT: {
    metricKey: 'listing.event.public.view_advert'
  },
  SIMILAR_LISTING: {
    metricKey: 'listing.event.public.similar_listing'
  },
  PHONE_CLICK: {
    metricKey: 'listing.event.public.phone_click'
  },
  EMAIL_AGENT_CLICK: {
    metricKey: 'listing.event.public.email_agent_click'
  },
  AGENTSTAFF_PROFILE_CLICK: {
    metricKey: 'listing.event.public.agentstaff_profile_click'
  },
  VIEW_AGENT_DETAILS_CLICK: {
    metricKey: 'listing.event.public.agent_details_click'
  },
  INSPECTION_TIME_SAVED: {
    metricKey: 'listing.event.public.inspection_time_saved'
  },
  AUCTION_TIME_SAVED: {
    metricKey: 'listing.event.public.add_auction_to_calendar'
  },
  BOOK_INSPECTION_CLICK: {
    metricKey: 'listing.event.public.book_inspection_click'
  },
  EXPAND_PHOTO_VIEW: {
    metricKey: 'listing.event.public.expand_photo_view'
  },
  VIEW_FLOOR_PLAN: {
    metricKey: 'listing.event.public.view_floorplan'
  },
  VIEW_3D_TOUR: {
    metricKey: 'listing.event.public.view_3d_tour'
  },
  EXPAND_TEXT: {
    metricKey: 'listing.event.public.expand_text'
  },
  PAGE_VIEW: {
    metricKey: 'listing.event.public.view'
  },
  APPLY_ONLINE: {
    metricKey: 'listing.event.public.apply_online'
  },
  VIEW_DRIVING_DIRECTIONS: {
    metricKey: 'listing.event.public.view_driving_directions'
  },
  TWITTER_SHARE: {
    metricKey: 'listing.event.public.twitter_share'
  },
  FACEBOOK_SHARE: {
    metricKey: 'listing.event.public.facebook_share'
  },
  MAPPING_TERRITORY_PLANNING: {
    metricKey: 'listing.event.public.mapping_territory_planning'
  },
  MAPPING_EASEMENT: {
    metricKey: 'listing.event.public.mapping_easement'
  },
  MAPPING_UNIMPROVED_LAND: {
    metricKey: 'listing.event.public.mapping_unimproved_land'
  },
  MAPPING_CONTOURS: {
    metricKey: 'listing.event.public.mapping_contours'
  },
  MAPPING_SCHOOL_PPA: {
    metricKey: 'listing.event.public.mapping_school_ppa'
  },
  DEVELOPMENT_APPLICATION: {
    metricKey: 'listing.event.public.development_application'
  },
  MAPPING_LAND_DETAILS_CLICK: {
    metricKey: 'listing.event.public.mapping.land_details_click'
  },
  MAPPING_AREA_MAP_CLICK: {
    metricKey: 'listing.event.public.mapping.area_map_click'
  },
  MAPPING_AERIAL_VIEW_CLICK: {
    metricKey: 'listing.event.public.mapping.aerial_view_click'
  },
  MAPPING_STREET_VIEW_CLICK: {
    metricKey: 'listing.event.public.mapping.street_view_click'
  },
  MAPPING_WALK_SCORE_CLICK: {
    metricKey: 'listing.event.public.mapping.walk_score_click'
  },
  PROPERTYALERT: {
    metricKey: 'listing.event.server.propertyalert'
  },
  ENQUIRE_LISTING: {
    metricKey: 'listing.event.server.enquire_listing'
  },
  EMAIL_FRIEND: {
    metricKey: 'listing.event.server.email_friend'
  },
  ADD_WATCHLIST: {
    metricKey: 'listing.event.server.add_watchlist'
  },
  TRIP_PLAN: {
    metricKey: 'listing.event.server.trip_plan'
  },
  LISTING_RELIST: {
    metricKey: 'listing.event.server.listing_relist'
  },
  OPEN_HOUSES: {
    metricKey: 'listing.event.derived.open_houses'
  },
  DOM: {
    metricKey: 'listing.event.derived.dom'
  },
  CONTACT_AGENT: {
    metricKey: 'listing.event.derived.contact_agent_count'
  },
  PHONE_AGENT: {
    metricKey: 'listing.event.derived.phone_agent_count'
  },
  MAP_INTERACTIONS_COUNT: {
    metricKey: 'listing.event.derived.map_interactions_count'
  },
  SOCIAL_MEDIA_SHARE_COUNT: {
    metricKey: 'listing.event.derived.social_media_share_count'
  },
  TOTAL_PHOTO_VIEW: {
    metricKey: 'listing.event.derived.photo_view_count'
  },
  LOCALITY_VIEW: {
    metricKey: 'locality.event.public.view'
  },
  LOCALITY_ADVANCED_SEARCH_VIEW: {
    metricKey: 'locality.event.advanced_search.view'
  },
  AGENTSTAFF_PROFILE_PHONE_CLICK: {
    metricKey: 'agentstaff.event.public.phone_click'
  },
  AGENTSTAFF_PROFILE_EMAIL_CLICK: {
    metricKey: 'agentstaff.event.public.email_click'
  },
  MOBILE_VIEW_AGENT_TAB: {
    metricKey: 'listing.event.public.mobile.view_agent_tab'
  },
  MOBILE_CONTACT_AGENT_TOOLBAR_CLICK: {
    metricKey: 'listing.event.public.mobile.contact_agent_toolbar'
  },
  MOBILE_VIEW_AGENT_DETAILS_CLICK: {
    metricKey: 'listing.event.public.mobile.view_agent_details'
  },
  MOBILE_CALL_AGENT_CLICK: {
    metricKey: 'listing.event.public.mobile.call_agent'
  },
  MOBILE_CALL_AGENCY_CLICK: {
    metricKey: 'listing.event.public.mobile.call_agency'
  },
  MOBILE_CONTACT_AGENT_CLICK: {
    metricKey: 'listing.event.public.mobile.contact_agent_pressed'
  },
  MOBILE_CONTACT_AGENCY_CLICK: {
    metricKey: 'listing.event.public.mobile.contact_agency_pressed'
  },
  MOBILE_AGENT_SAVE_TO_ADDRESS_BOOK_CLICK: {
    metricKey: 'listing.event.public.mobile.add_agent_to_contacts'
  },
  MOBILE_AGENCY_WEBSITE_CLICK: {
    metricKey: 'listing.event.public.mobile.view_agency_website'
  },
  MOBILE_CONTACT_AGENT_SEND_CLICK: {
    metricKey: 'listing.event.public.mobile.agent_form_send'
  },
  MOBILE_EMAIL_CTA_CLICK: {
    metricKey: 'listing.event.public.mobile.email_CTA'
  },
  MOBILE_VIDEO_PLAY: {
    metricKey: 'listing.event.public.mobile.view_video'
  },
  MOBILE_3D_WALKTHROUGH_CLICK: {
    metricKey: 'listing.event.public.mobile.view_3D'
  },
  MOBILE_VIEW_NEW_DEVELOPMENT: {
    metricKey: 'listing.event.public.mobile.view_new_development'
  },
  MOBILE_VIEW_NEW_DEVELOPMENT_WEBSITE: {
    metricKey: 'listing.event.public.mobile.view_new_development_website'
  },
  MOBILE_VIEW_MAP: {
    metricKey: 'listing.event.public.mobile.view_map'
  },
  MOBILE_SMS_SHARE: {
    metricKey: 'listing.event.public.mobile.sms_share'
  },
  M_CONTACT_AGENT_SEND_CLICK: {
    metricKey: 'listing.event.public.m.agent_form_send'
  },
  M_CALL_AGENT_CLICK: {
    metricKey: 'listing.event.public.m.call_agent'
  },
  M_VIEW_FULL_WEBSITE_CLICK: {
    metricKey: 'listing.event.public.m.view_full_website_click'
  },
  PROPERTY_OF_THE_WEEK_COUNTRY_CLICK: {
    metricKey: 'listing.event.public.property_of_the_week_country_click'
  },
  PROPERTY_OF_THE_WEEK_COUNTRY_IMPRESSION: {
    metricKey: 'listing.event.public.property_of_the_week_country_impression'
  },
  PROPERTY_OF_THE_WEEK_STATE_CLICK: {
    metricKey: 'listing.event.public.property_of_the_week_state_click'
  },
  PROPERTY_OF_THE_WEEK_STATE_IMPRESSION: {
    metricKey: 'listing.event.public.property_of_the_week_state_impression'
  },
  PROPERTY_OF_THE_WEEK_REGION_CLICK: {
    metricKey: 'listing.event.public.property_of_the_week_region_click'
  },
  PROPERTY_OF_THE_WEEK_REGION_IMPRESSION: {
    metricKey: 'listing.event.public.property_of_the_week_region_impression'
  },
  PROPERTY_OF_THE_WEEK_DISTRICT_CLICK: {
    metricKey: 'listing.event.public.property_of_the_week_district_click'
  },
  PROPERTY_OF_THE_WEEK_DISTRICT_IMPRESSION: {
    metricKey: 'listing.event.public.property_of_the_week_district_impression'
  },
  FEATURED_PROPERTY_CLICK: {
    metricKey: 'listing.event.public.featured_property_click'
  },
  FEATURED_PROPERTY_IMPRESSION: {
    metricKey: 'listing.event.public.featured_property_impression'
  },
  DREAM_HOME_CLICK: {
    metricKey: 'listing.event.public.dream_home_click'
  },
  DREAM_HOME_IMPRESSION: {
    metricKey: 'listing.event.public.dream_home_impression'
  },
  TOP_SPOT_HOME_CLICK: {
    metricKey: 'listing.event.public.top_spot_click'
  },
  TOP_SPOT_HOME_IMPRESSION: {
    metricKey: 'listing.event.public.top_spot_impression'
  },
  AGENT_OF_THE_WEEK_CLICK: {
    metricKey: 'agent.event.public.agent_of_the_week_click'
  },
  AGENT_OF_THE_WEEK_IMPRESSION: {
    metricKey: 'agent.event.public.agent_of_the_week_impression'
  },
  AGENTSTAFF_OF_THE_WEEK_CLICK: {
    metricKey: 'agentstaff.event.public.agent_of_the_week_click'
  },
  AGENTSTAFF_OF_THE_WEEK_IMPRESSION: {
    metricKey: 'agentstaff.event.public.agent_of_the_week_click'
  },
  VIEW_AGENCY_PROFILE: {
    metricKey: 'listing.event.view_agency_profile'
  },
  GOTO_ONLINE_AUCTION: {
    metricKey: 'listing.event.public.go_to_online_auction_click'
  },
  EARLY_ACCESS_REQUEST_INSPECTION: {
    metricKey: 'listing.event.public.early_access_request_inspection'
  },
  EARLY_ACCESS_EXPAND_MAP: {
    metricKey: 'listing.event.public.early_access_expand_map'
  }
};
export default AnalyticsMetric;